import React from 'react';

export default function (props) {
  return (
    <button className={props.className} onClick={props.onClick}>
      {props.value}
    </button>
  );
}



// WEBPACK FOOTER //
// ./src/components/elements/Button.js